import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchModulesByFormation = createAsyncThunk(
  "modules/fetchByFormation",
  async (formationId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/modules/formation/${formationId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const createModule = createAsyncThunk(
  "modules/create",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/modules", formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur création");
    }
  }
);

export const updateModule = createAsyncThunk(
  "modules/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(`/modules/${id}`, formData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur modification");
    }
  }
);

export const deleteModule = createAsyncThunk(
  "modules/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/modules/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur suppression");
    }
  }
);

const moduleSlice = createSlice({
  name: "modules",
  initialState: { list: [], loading: false, error: null, success: null, total: 0, page: 1, pages: 1 },
  reducers: {
    clearModuleMessages: (state) => { state.error = null; state.success = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModulesByFormation.pending,   (state) => { state.loading = true; })
      .addCase(fetchModulesByFormation.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
        state.total = action.payload.total ?? state.list.length;
        state.page = action.payload.page ?? 1;
        state.pages = action.payload.pages ?? 1;
      })
      .addCase(fetchModulesByFormation.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createModule.fulfilled, (state, action) => { state.list.push(action.payload); state.success = "Module créé."; })
      .addCase(createModule.rejected,  (state, action) => { state.error = action.payload; })
      .addCase(updateModule.fulfilled, (state, action) => {
        const idx = state.list.findIndex((m) => m._id === action.payload._id);
        if (idx !== -1) state.list[idx] = action.payload;
        state.success = "Module mis à jour.";
      })
      .addCase(deleteModule.fulfilled, (state, action) => { state.list = state.list.filter((m) => m._id !== action.payload); state.success = "Module supprimé."; });
  },
});

export const { clearModuleMessages } = moduleSlice.actions;
export default moduleSlice.reducer;
